/*
*  Method to focus input after click on something
*/

export const bypassFocusTo = function (domID) {

    const fakeInput = focusOnFake();
    let counter = 0;
    const waitAndFocus = setInterval(() => {

        // now we can focus on the target input
        const targetElement = document.getElementById(domID);

        if(!targetElement){
            if(counter>20){
                return clearInterval(waitAndFocus);
            }
            else {
                return counter++;
            }
        }

        targetElement.focus();
        fakeInput.remove();
        clearInterval(waitAndFocus);

    }, 300);

};
const focusOnFake = function(){
    // create invisible dummy input to receive the focus first
    const fakeInput = document.createElement('input');
    fakeInput.setAttribute('type', 'text');
    fakeInput.style.position = 'absolute';
    fakeInput.style.opacity = 0;
    fakeInput.style.height = 0;
    fakeInput.style.fontSize = '16px'; // disable auto zoom

    // you may need to append to another element depending on the browser's auto
    // zoom/scroll behavior
    document.body.prepend(fakeInput);

    // focus so that subsequent async focus will work
    fakeInput.focus();
    return fakeInput;
};
